import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CakeCanvas from "./CakeCanvas";
import "./Home.css";

export default function Home() {
  return (
    <section className="hero">
      <div className="hero-container">

        {/* TEXT */}
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <span className="eyebrow">Premium Handcrafted Bakery</span>

          <h1>
            Cakes,<br />
            thoughtfully designed.
          </h1>

          <p>
            Premium handcrafted cakes made with intention,
            balance, and an obsessive attention to detail.
          </p>
          <a
  href="https://almondsoftwares.in"
  target="_blank"
  rel="noopener noreferrer"
  className="home-dev"
>
  Developed by Almond Softwares
</a>

          <div className="hero-buttons">
            <Link to="/contact" className="btn-primary">
              Order Now
            </Link>

            <Link to="/menu" className="btn-secondary">
              View Menu
            </Link>
          </div>
        </motion.div>

        {/* VISUAL */}
        <motion.div
          className="hero-visual"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <CakeCanvas />
        </motion.div>

      </div>
    </section>
  );
}
